import React, { useState } from 'react';
import { useFormik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { AuthenticationSngpcData } from '../../../../interfaces/authentication';

import { createUser } from '../../../../store/sngpc/actions';
import { AppState } from '../../../../store';

import Text from '../../../ui/Text';
import Input from '../../../ui/Form/Input';
import BaseForm from '../Form';

import * as Styles from './FormAccountStyles';

const validate = (values: AuthenticationSngpcData): Partial<AuthenticationSngpcData> => {
  const errors: Partial<AuthenticationSngpcData> = {};

  if (!values.email) {
    errors.email = 'O e-mail é obrigatório';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
    errors.email = 'E-mail inválido';
  }

  if (!values.password) {
    errors.password = 'A senha é obrigatória';
  } else if (
    values.password.length < 8 ||
    !/(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?!.*\s)(?=.*[!@#$*])/.test(values.password)
  ) {
    errors.password =
      // eslint-disable-next-line max-len
      'Sua senha deve conter no mínimo: 8 caracteres, 1 letra maiúscula, 1 letra minúscula, 1 número e 1 caractere especial';
  }

  return errors;
};

const FormAccount: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { currentStep, loading, error, empresaSelecionada, responsavelSelecionado, transactionToken } = useSelector(
    (state: AppState) => state.sngpc,
  );

  const [passwordShow, setPasswordShow] = useState(false);

  const togglePasswordVisiblity = (): void => {
    setPasswordShow(!passwordShow);
  };

  const showError = (inputName: keyof AuthenticationSngpcData): boolean =>
    Boolean(form.errors[inputName] && form.touched[inputName]);

  const form = useFormik<AuthenticationSngpcData>({
    initialValues: {
      email: '',
      password: '',
    },
    validate,
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: async (values) => {
      try {
        const { email, password } = values;
        if (empresaSelecionada && responsavelSelecionado) {
          const payload = {
            empresa: empresaSelecionada,
            responsavel: responsavelSelecionado,
            transactionToken,
            credentials: {
              email,
              password,
            },
          };

          dispatch(createUser(payload, history));
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
      }
    },
  });

  return (
    <Styles.Container>
      <Styles.Header>
        <Styles.Title>Criar conta Memed</Styles.Title>
        <Text color="black80" align="justify">
          Agora que já temos os dados cadastrais da sua farmácia, finalize o processo criando sua conta na Memed.
        </Text>
      </Styles.Header>

      <BaseForm onSubmit={form.handleSubmit} loading={loading} error={error} step={currentStep}>
        <Input
          required
          onInputChange={form.handleChange}
          errors={showError('email') ? form.errors.email : undefined}
          name="email"
          label="E-mail"
          type="text"
          placeholder="Digite seu e-mail"
        />

        <Input
          required
          onInputChange={form.handleChange}
          errors={showError('password') ? form.errors.password : undefined}
          name="password"
          label="Senha"
          type={passwordShow ? 'text' : 'password'}
          placeholder="Digite uma senha"
          height={114}
          passwordHandlers={{
            passwordShow,
            handlePasswordVisibility: () => togglePasswordVisiblity(),
          }}
        />
      </BaseForm>
    </Styles.Container>
  );
};

export default FormAccount;
